// PLAN MANAGEMENT
export const getDepotSavedChecksum = (depotCode) => {
  try {
    return JSON.parse(localStorage.getItem("depotChecksum"))[depotCode] || null;
  } catch (err) {
    return null;
  }
};

export const saveDepotChecksum = (depotCode, checksum) => {
  let storedValue;
  try {
    storedValue = JSON.parse(localStorage.getItem("depotChecksum")) || {};
  } catch (err) {
    storedValue = {};
  }
  storedValue[depotCode] = checksum;
  localStorage.setItem("depotChecksum", JSON.stringify(storedValue));
};

export const deleteDepotChecksum = (depotCode) => {
  let storedValue;
  try {
    storedValue = JSON.parse(localStorage.getItem("depotChecksum")) || {};
  } catch (err) {
    storedValue = {};
  }
  delete storedValue[depotCode];
  localStorage.setItem("depotChecksum", JSON.stringify(storedValue));
};

export const processTemplateLocks = ({
  userCode,
  matrixProfile,
  driverProfileLocks,
  driverDayLocks,
  routeDayLocks,
}) => {
  const storedMatrixProfileChecksum = getTemplateSavedChecksum(
    matrixProfile.templateId
  );
  matrixProfile.lockedByYou = matrixProfile.lockedByUserCode === userCode;
  matrixProfile.lockedInDifferentBrowser =
    storedMatrixProfileChecksum !== matrixProfile.checksum &&
    matrixProfile.lockedByYou;

  if (matrixProfile.lockedInDifferentBrowser && storedMatrixProfileChecksum)
    matrixProfile.checksum = storedMatrixProfileChecksum;
  else if (!matrixProfile.lockedByYou && storedMatrixProfileChecksum)
    deleteTemplateChecksum(matrixProfile.templateId);

  const storedDriverProfileLocks = getSavedDepotDriverProfileChecksums({
    dayOfWeek: matrixProfile.day,
    depotCode: matrixProfile.depotCode,
  });
  Object.entries(driverProfileLocks).forEach(
    ([driverCode, driverProfileLock]) => {
      const storedDriverProfileChecksum = storedDriverProfileLocks[driverCode];

      driverProfileLock.lockedByYou =
        driverProfileLock.lockedByUserCode === userCode;

      driverProfileLock.lockedInDifferentBrowser =
        storedDriverProfileChecksum !== driverProfileLock.checksum &&
        driverProfileLock.lockedByYou;

      if (
        driverProfileLock.lockedInDifferentBrowser &&
        storedDriverProfileChecksum
      )
        driverProfileLock.checksum = storedDriverProfileChecksum;
      else if (!driverProfileLock.lockedByYou && storedDriverProfileChecksum)
        delete storedDriverProfileLocks[driverCode];
    }
  );
  saveDepotDriverProfileChecksums({
    dayOfWeek: matrixProfile.day,
    depotCode: matrixProfile.depotCode,
    driverProfilesChecksums: storedDriverProfileLocks,
  });

  const storedDriverDayLocks = getSavedDepotDriverDayChecksums({
    dayOfWeek: matrixProfile.day,
    depotCode: matrixProfile.depotCode,
  });
  Object.entries(driverDayLocks).forEach(([driverCode, driverDayLock]) => {
    const storedDriverDayChecksum = storedDriverDayLocks[driverCode];
    driverDayLock.lockedByYou = driverDayLock.lockedByUserCode === userCode;
    driverDayLock.lockedInDifferentBrowser =
      storedDriverDayChecksum !== driverDayLock.checksum &&
      driverDayLock.lockedByYou;

    if (driverDayLock.lockedInDifferentBrowser && storedDriverDayChecksum)
      driverDayLock.checksum = storedDriverDayChecksum;
    else if (!driverDayLock.lockedByYou && storedDriverDayChecksum)
      delete storedDriverDayLocks[driverCode];
  });
  saveDepotDriverDayChecksums({
    dayOfWeek: matrixProfile.day,
    depotCode: matrixProfile.depotCode,
    driverDaysChecksums: storedDriverDayLocks,
  });

  const storedRouteDayLocks = getSavedDepotRouteDayChecksums({
    dayOfWeek: matrixProfile.day,
    depotCode: matrixProfile.depotCode,
  });
  Object.entries(routeDayLocks).forEach(([routeCode, routeDayLock]) => {
    const storedRouteDayChecksum = storedRouteDayLocks[routeCode];
    routeDayLock.lockedByYou = routeDayLock.lockedByUserCode === userCode;
    routeDayLock.lockedInDifferentBrowser =
      storedRouteDayChecksum !== routeDayLock.checksum &&
      routeDayLock.lockedByYou;

    if (routeDayLock.lockedInDifferentBrowser && storedRouteDayChecksum)
      routeDayLock.checksum = storedRouteDayChecksum;
    else if (!routeDayLock.lockedByYou && storedRouteDayChecksum)
      delete storedRouteDayLocks[routeCode];
  });
  saveDepotRouteDayChecksums({
    dayOfWeek: matrixProfile.day,
    depotCode: matrixProfile.depotCode,
    routeDaysChecksums: storedRouteDayLocks,
  });
};

export const processTemplateLocksRefresh = ({
  userCode,
  depotCode,
  dayOfWeek,
  driverDayLocks,
  routeDayLocks,
  newDriverDayLocks,
  newRouteDayLocks,
}) => {
  const refreshedDriverDayLocks = { ...driverDayLocks };
  const refreshedRouteDayLocks = { ...routeDayLocks };
  let hasChangedChecksum = false;

  // Driver day locks
  Object.entries(newDriverDayLocks).forEach(
    ([driverCode, newDriverDayLock]) => {
      const driverDayLock = driverDayLocks[driverCode];

      // If driver day lock was not present and it now is
      if (!driverDayLock) {
        hasChangedChecksum = true;
        // set driver day lock as changed
        refreshedDriverDayLocks[driverCode] = {
          ...newDriverDayLock,
          checksum: null,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
          changed: true,
        };
        // Else if current driver day lock is already marked as changed, do nothing.
      } else if (driverDayLock.changed) {
        hasChangedChecksum = true;
        return;
        // Else if current driver day lock checksum is not equal to new lock checksum,
      } else if (driverDayLock.checksum !== newDriverDayLock.checksum) {
        hasChangedChecksum = true;
        // set driver day lock as changed
        refreshedDriverDayLocks[driverCode] = {
          ...newDriverDayLock,
          checksum: null,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
          changed: true,
        };
        // Else if driver day  was locked by you in this session
      } else if (
        driverDayLock.lockedByYou &&
        !driverDayLock.lockedInDifferentBrowser
      ) {
        // and it is no longer locked by you
        if (newDriverDayLock.lockedByUserCode !== userCode) {
          // refresh driver day lock state
          refreshedDriverDayLocks[driverCode] = {
            ...newDriverDayLock,
            lockedByYou: false,
            lockedInDifferentBrowser: false,
          };
          // delete stored checksum
          deleteDriverDayChecksum({
            dayOfWeek,
            driverCode,
          });
        } // else if no changes do nothing
      }
      // Else if driver day was locked by someone else, or by you in other session
      else if (driverDayLock.lockedByUserCode) {
        // and it is no longer locked by the same user
        if (
          newDriverDayLock.lockedByUserCode !== driverDayLock.lockedByUserCode
        ) {
          // refresh driver day lock state
          refreshedDriverDayLocks[driverCode] = {
            ...newDriverDayLock,
            lockedByYou: false,
            lockedInDifferentBrowser: false,
          };
        } // else if no changes do nothing
        // Else if driver day was unlocked
      } else {
        // and it is now locked by you
        if (newDriverDayLock.lockedByUserCode === userCode) {
          // refresh driver day lock state to indicate that it has been locked by you in other session
          refreshedDriverDayLocks[driverCode] = {
            ...newDriverDayLock,
            lockedByYou: true,
            lockedInDifferentBrowser: true,
          };
          // and it is now locked by someone else
        } else if (
          newDriverDayLock.lockedByUserCode &&
          newDriverDayLock.lockedByUserCode !== userCode
        ) {
          // refresh driver day lock state
          refreshedDriverDayLocks[driverCode] = {
            ...newDriverDayLock,
            lockedByYou: false,
            lockedInDifferentBrowser: false,
          };
        } // else if no changes do nothing
      }
    }
  );

  // Route day locks
  Object.entries(newRouteDayLocks).forEach(([routeCode, newRouteDayLock]) => {
    const routeDayLock = routeDayLocks[routeCode];
    // If route day lock was not present and it now is
    if (!routeDayLock) {
      hasChangedChecksum = true;
      // set route day lock as changed
      refreshedRouteDayLocks[routeCode] = {
        ...newRouteDayLock,
        checksum: null,
        lockedByYou: false,
        lockedInDifferentBrowser: false,
        changed: true,
      };
      // Else if current route day lock is already marked as changed, do nothing.
    } else if (routeDayLock.changed) {
      hasChangedChecksum = true;
      return;
      // Else if current route day lock checksum is not equal to new lock checksum,
    } else if (routeDayLock.checksum !== newRouteDayLock.checksum) {
      hasChangedChecksum = true;
      // set route day lock as changed
      refreshedRouteDayLocks[routeCode] = {
        ...newRouteDayLock,
        checksum: null,
        lockedByYou: false,
        lockedInDifferentBrowser: false,
        changed: true,
      };
      // Else if route day  was locked by you in this session
    } else if (
      routeDayLock.lockedByYou &&
      !routeDayLock.lockedInDifferentBrowser
    ) {
      // and it is no longer locked by you
      if (newRouteDayLock.lockedByUserCode !== userCode) {
        // refresh route day lock state
        refreshedRouteDayLocks[routeCode] = {
          ...newRouteDayLock,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
        };
        // delete stored checksum
        deleteRouteDayChecksum({
          dayOfWeek,
          depotCode,
          routeCode,
        });
      } // else if no changes do nothing
    }
    // Else if route day was locked by someone else, or by you in other session
    else if (routeDayLock.lockedByUserCode) {
      // and it is no longer locked by the same user
      if (newRouteDayLock.lockedByUserCode !== routeDayLock.lockedByUserCode) {
        // refresh route day lock state
        refreshedRouteDayLocks[routeCode] = {
          ...newRouteDayLock,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
        };
      } // else if no changes do nothing
      // Else if route day was unlocked
    } else {
      // and it is now locked by you
      if (newRouteDayLock.lockedByUserCode === userCode) {
        // refresh route day lock state to indicate that it has been locked by you in other session
        refreshedRouteDayLocks[routeCode] = {
          ...newRouteDayLock,
          lockedByYou: true,
          lockedInDifferentBrowser: true,
        };
        // and it is now locked by someone else
      } else if (
        newRouteDayLock.lockedByUserCode &&
        newRouteDayLock.lockedByUserCode !== userCode
      ) {
        // refresh route day lock state
        refreshedRouteDayLocks[routeCode] = {
          ...newRouteDayLock,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
        };
      } // else if no changes do nothing
    }
  });

  return {
    refreshedDriverDayLocks,
    refreshedRouteDayLocks,
    hasChangedChecksum,
  };
};

export const getTemplateSavedChecksum = (templateId) => {
  try {
    return (
      JSON.parse(localStorage.getItem("templateChecksum"))[templateId] || null
    );
  } catch (err) {
    return null;
  }
};

export const saveTemplateChecksum = (templateId, checksum) => {
  let storedValue;
  try {
    storedValue = JSON.parse(localStorage.getItem("templateChecksum")) || {};
  } catch (err) {
    storedValue = {};
  }
  storedValue[templateId] = checksum;
  localStorage.setItem("templateChecksum", JSON.stringify(storedValue));
};

export const deleteTemplateChecksum = (templateId) => {
  let storedValue;
  try {
    storedValue = JSON.parse(localStorage.getItem("templateChecksum")) || {};
  } catch (err) {
    storedValue = {};
  }
  delete storedValue[templateId];
  localStorage.setItem("templateChecksum", JSON.stringify(storedValue));
};

export const saveRouteDayChecksum = ({
  dayOfWeek,
  depotCode,
  routeCode,
  checksum,
}) => {
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(`${dayOfWeek}_${depotCode}_routeDayChecksum`)
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  storedValue[routeCode] = checksum;
  localStorage.setItem(
    `${dayOfWeek}_${depotCode}_routeDayChecksum`,
    JSON.stringify(storedValue)
  );
};

export const deleteRouteDayChecksum = ({ dayOfWeek, depotCode, routeCode }) => {
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(`${dayOfWeek}_${depotCode}_routeDayChecksum`)
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  delete storedValue[routeCode];
  localStorage.setItem(
    `${dayOfWeek}_${depotCode}_routeDayChecksum`,
    JSON.stringify(storedValue)
  );
};

export const getSavedDepotRouteDayChecksums = ({ dayOfWeek, depotCode }) => {
  try {
    return (
      JSON.parse(
        localStorage.getItem(`${dayOfWeek}_${depotCode}_routeDayChecksum`)
      ) || {}
    );
  } catch (err) {
    return {};
  }
};

export const getSavedDepotDriverProfileChecksums = ({
  dayOfWeek,
  depotCode,
}) => {
  try {
    return (
      JSON.parse(
        localStorage.getItem(`${dayOfWeek}_${depotCode}_driverProfileChecksum`)
      ) || {}
    );
  } catch (err) {
    return {};
  }
};

export const getSavedDepotDriverDayChecksums = ({ dayOfWeek, depotCode }) => {
  try {
    return (
      JSON.parse(
        localStorage.getItem(`${dayOfWeek}_${depotCode}_driverDayChecksum`)
      ) || {}
    );
  } catch (err) {
    return {};
  }
};

export const saveDepotRouteDayChecksums = ({
  dayOfWeek,
  depotCode,
  routeDaysChecksums,
}) =>
  localStorage.setItem(
    `${dayOfWeek}_${depotCode}_routeDayChecksum`,
    JSON.stringify(routeDaysChecksums)
  );

export const deleteDepotRouteDayChecksums = ({ dayOfWeek, depotCode }) => {
  try {
    localStorage.removeItem(`${dayOfWeek}_${depotCode}_routeDayChecksum`);
  } catch {}
};

export const saveDepotDriverProfileChecksums = ({
  dayOfWeek,
  depotCode,
  driverProfilesChecksums,
}) =>
  localStorage.setItem(
    `${dayOfWeek}_${depotCode}_driverProfileChecksum`,
    JSON.stringify(driverProfilesChecksums)
  );

export const deleteDepotDriverProfileChecksums = ({ dayOfWeek, depotCode }) => {
  try {
    localStorage.removeItem(`${dayOfWeek}_${depotCode}_driverProfileChecksum`);
  } catch {}
};

export const saveDepotDriverDayChecksums = ({
  dayOfWeek,
  depotCode,
  driverDaysChecksums,
}) =>
  localStorage.setItem(
    `${dayOfWeek}_${depotCode}_driverDayChecksum`,
    JSON.stringify(driverDaysChecksums)
  );

export const deleteDepotDriverDayChecksums = ({ dayOfWeek, depotCode }) => {
  try {
    localStorage.removeItem(`${dayOfWeek}_${depotCode}_driverDayChecksum`);
  } catch {}
};

export const saveDriverProfileChecksum = ({
  dayOfWeek,
  driverCode,
  checksum,
}) => {
  const [depotCode] = driverCode.split("*");
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(`${dayOfWeek}_${depotCode}_driverProfileChecksum`)
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  storedValue[driverCode] = checksum;
  localStorage.setItem(
    `${dayOfWeek}_${depotCode}_driverProfileChecksum`,
    JSON.stringify(storedValue)
  );
};

export const deleteDriverProfileChecksum = ({ dayOfWeek, driverCode }) => {
  const [depotCode] = driverCode.split("*");
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(`${dayOfWeek}_${depotCode}_driverProfileChecksum`)
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  delete storedValue[driverCode];
  localStorage.setItem(
    `${dayOfWeek}_${depotCode}_driverProfileChecksum`,
    JSON.stringify(storedValue)
  );
};

export const saveDriverDayChecksum = ({ dayOfWeek, driverCode, checksum }) => {
  const [depotCode] = driverCode.split("*");
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(`${dayOfWeek}_${depotCode}_driverDayChecksum`)
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  storedValue[driverCode] = checksum;
  localStorage.setItem(
    `${dayOfWeek}_${depotCode}_driverDayChecksum`,
    JSON.stringify(storedValue)
  );
};

export const deleteDriverDayChecksum = ({ dayOfWeek, driverCode }) => {
  const [depotCode] = driverCode.split("*");
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(`${dayOfWeek}_${depotCode}_driverDayChecksum`)
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  delete storedValue[driverCode];
  localStorage.setItem(
    `${dayOfWeek}_${depotCode}_driverDayChecksum`,
    JSON.stringify(storedValue)
  );
};

// DRIVER MANAGEMENT
export const processDriverManagementLocks = ({
  userCode,
  depotCode,
  driverProfileLocks,
  matrixDays,
}) => {
  const storedDriverProfileLocks =
    getSavedDriverManagementDriverProfileChecksums({
      depotCode,
    });
  Object.entries(driverProfileLocks).forEach(
    ([driverCode, driverProfileLock]) => {
      const storedDriverProfileChecksum = storedDriverProfileLocks[driverCode];

      driverProfileLock.lockedByYou =
        driverProfileLock.lockedByUserCode === userCode;

      driverProfileLock.lockedInDifferentBrowser =
        storedDriverProfileChecksum !== driverProfileLock.checksum &&
        driverProfileLock.lockedByYou;

      if (
        driverProfileLock.lockedInDifferentBrowser &&
        storedDriverProfileChecksum
      )
        driverProfileLock.checksum = storedDriverProfileChecksum;
      else if (!driverProfileLock.lockedByYou && storedDriverProfileChecksum)
        delete storedDriverProfileLocks[driverCode];
    }
  );
  saveDriverManagementDriverProfileChecksums({
    depotCode,
    driverProfilesChecksums: storedDriverProfileLocks,
  });

  Object.entries(matrixDays).forEach(
    ([dayOfWeek, { driverDayLocks, routeDayLocks }]) => {
      const storedDriverDayLocks = getSavedDriverManagementDriverDayChecksums({
        dayOfWeek,
        depotCode,
      });
      Object.entries(driverDayLocks).forEach(([driverCode, driverDayLock]) => {
        const storedDriverDayChecksum = storedDriverDayLocks[driverCode];
        driverDayLock.lockedByYou = driverDayLock.lockedByUserCode === userCode;
        driverDayLock.lockedInDifferentBrowser =
          storedDriverDayChecksum !== driverDayLock.checksum &&
          driverDayLock.lockedByYou;

        if (driverDayLock.lockedInDifferentBrowser && storedDriverDayChecksum)
          driverDayLock.checksum = storedDriverDayChecksum;
        else if (!driverDayLock.lockedByYou && storedDriverDayChecksum)
          delete storedDriverDayLocks[driverCode];
      });
      saveDriverManagementDriverDayChecksums({
        dayOfWeek,
        depotCode,
        driverDaysChecksums: storedDriverDayLocks,
      });

      const storedRouteDayLocks = getSavedDriverManagementRouteDayChecksums({
        dayOfWeek,
        depotCode,
      });
      Object.entries(routeDayLocks).forEach(([routeCode, routeDayLock]) => {
        const storedRouteDayChecksum = storedRouteDayLocks[routeCode];
        routeDayLock.lockedByYou = routeDayLock.lockedByUserCode === userCode;
        routeDayLock.lockedInDifferentBrowser =
          storedRouteDayChecksum !== routeDayLock.checksum &&
          routeDayLock.lockedByYou;

        if (routeDayLock.lockedInDifferentBrowser && storedRouteDayChecksum)
          routeDayLock.checksum = storedRouteDayChecksum;
        else if (!routeDayLock.lockedByYou && storedRouteDayChecksum)
          delete storedRouteDayLocks[routeCode];
      });
      saveDriverManagementRouteDayChecksums({
        dayOfWeek,
        depotCode,
        routeDaysChecksums: storedRouteDayLocks,
      });
    }
  );
};

export const processDriverManagementWeekLocksRefresh = ({
  userCode,
  depotCode,
  driverProfileLocks,
  matrixDays,
  newDriverProfileLocks,
  newMatrixDays,
}) => {
  const refreshedDriverProfileLocks = { ...driverProfileLocks };
  const getRefreshedMatrixDay = (dayOfWeek) => ({
    ...matrixDays[dayOfWeek],
    driverDayLocks: { ...matrixDays[dayOfWeek].driverDayLocks },
    routeDayLocks: { ...matrixDays[dayOfWeek].routeDayLocks },
  });
  const refreshedMatrixDays = {
    0: { ...getRefreshedMatrixDay(0) },
    1: { ...getRefreshedMatrixDay(1) },
    2: { ...getRefreshedMatrixDay(2) },
    3: { ...getRefreshedMatrixDay(3) },
    4: { ...getRefreshedMatrixDay(4) },
    5: { ...getRefreshedMatrixDay(5) },
    6: { ...getRefreshedMatrixDay(6) },
  };
  let hasChangedChecksum = false;

  // Driver profile locks
  Object.entries(newDriverProfileLocks).forEach(
    ([driverCode, newDriverProfileLock]) => {
      const driverProfileLock = driverProfileLocks[driverCode];

      // If driver profile lock was not present and it now is
      if (!driverProfileLock) {
        hasChangedChecksum = true;
        // set driver profile lock as changed
        refreshedDriverProfileLocks[driverCode] = {
          ...newDriverProfileLock,
          checksum: null,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
          changed: true,
        };
        // Else if current driver profile lock is already marked as changed, do nothing.
      } else if (driverProfileLock.changed) {
        hasChangedChecksum = true;
        return;
        // Else if current driver profile lock checksum is not equal to new lock checksum,
      } else if (driverProfileLock.checksum !== newDriverProfileLock.checksum) {
        hasChangedChecksum = true;
        // set driver profile lock as changed
        refreshedDriverProfileLocks[driverCode] = {
          ...newDriverProfileLock,
          checksum: null,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
          changed: true,
        };
        // Else if driver profile  was locked by you in this session
      } else if (
        driverProfileLock.lockedByYou &&
        !driverProfileLock.lockedInDifferentBrowser
      ) {
        // and it is no longer locked by you
        if (newDriverProfileLock.lockedByUserCode !== userCode) {
          // refresh driver profile lock state
          refreshedDriverProfileLocks[driverCode] = {
            ...newDriverProfileLock,
            lockedByYou: false,
            lockedInDifferentBrowser: false,
          };
          // delete stored checksum
          deleteDriverManagementDriverProfileChecksum({ driverCode });
        } // else if no changes do nothing
      }
      // Else if driver profile was locked by someone else, or by you in other session
      else if (driverProfileLock.lockedByUserCode) {
        // and it is no longer locked by the same user
        if (
          newDriverProfileLock.lockedByUserCode !==
          driverProfileLock.lockedByUserCode
        ) {
          // refresh driver profile lock state
          refreshedDriverProfileLocks[driverCode] = {
            ...newDriverProfileLock,
            lockedByYou: false,
            lockedInDifferentBrowser: false,
          };
        } // else if no changes do nothing
        // Else if driver profile was unlocked
      } else {
        // and it is now locked by you
        if (newDriverProfileLock.lockedByUserCode === userCode) {
          // refresh driver profile lock state to indicate that it has been locked by you in other session
          refreshedDriverProfileLocks[driverCode] = {
            ...newDriverProfileLock,
            lockedByYou: true,
            lockedInDifferentBrowser: true,
          };
          // and it is now locked by someone else
        } else if (
          newDriverProfileLock.lockedByUserCode &&
          newDriverProfileLock.lockedByUserCode !== userCode
        ) {
          // refresh driver profile lock state
          refreshedDriverProfileLocks[driverCode] = {
            ...newDriverProfileLock,
            lockedByYou: false,
            lockedInDifferentBrowser: false,
          };
        } // else if no changes do nothing
      }
    }
  );

  Object.entries(newMatrixDays).forEach(
    ([
      dayOfWeek,
      { driverDayLocks: newDriverDayLocks, routeDayLocks: newRouteDayLocks },
    ]) => {
      // Driver day locks
      Object.entries(newDriverDayLocks).forEach(
        ([driverCode, newDriverDayLock]) => {
          const driverDayLock =
            matrixDays[dayOfWeek].driverDayLocks[driverCode];

          // If driver day lock was not present and it now is
          if (!driverDayLock) {
            hasChangedChecksum = true;
            // set driver day lock as changed
            refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
              ...newDriverDayLock,
              checksum: null,
              lockedByYou: false,
              lockedInDifferentBrowser: false,
              changed: true,
            };
            // Else if current driver day lock is already marked as changed, do nothing.
          } else if (driverDayLock.changed) {
            hasChangedChecksum = true;
            return;
            // Else if current driver day lock checksum is not equal to new lock checksum,
          } else if (driverDayLock.checksum !== newDriverDayLock.checksum) {
            hasChangedChecksum = true;
            // set driver day lock as changed
            refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
              ...newDriverDayLock,
              checksum: null,
              lockedByYou: false,
              lockedInDifferentBrowser: false,
              changed: true,
            };
            // Else if driver day  was locked by you in this session
          } else if (
            driverDayLock.lockedByYou &&
            !driverDayLock.lockedInDifferentBrowser
          ) {
            // and it is no longer locked by you
            if (newDriverDayLock.lockedByUserCode !== userCode) {
              // refresh driver day lock state
              refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
                ...newDriverDayLock,
                lockedByYou: false,
                lockedInDifferentBrowser: false,
              };
              // delete stored checksum
              deleteDriverManagementDriverDayChecksum({
                dayOfWeek,
                driverCode,
              });
            } // else if no changes do nothing
          }
          // Else if driver day was locked by someone else, or by you in other session
          else if (driverDayLock.lockedByUserCode) {
            // and it is no longer locked by the same user
            if (
              newDriverDayLock.lockedByUserCode !==
              driverDayLock.lockedByUserCode
            ) {
              // refresh driver day lock state
              refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
                ...newDriverDayLock,
                lockedByYou: false,
                lockedInDifferentBrowser: false,
              };
            } // else if no changes do nothing
            // Else if driver day was unlocked
          } else {
            // and it is now locked by you
            if (newDriverDayLock.lockedByUserCode === userCode) {
              // refresh driver day lock state to indicate that it has been locked by you in other session
              refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
                ...newDriverDayLock,
                lockedByYou: true,
                lockedInDifferentBrowser: true,
              };
              // and it is now locked by someone else
            } else if (
              newDriverDayLock.lockedByUserCode &&
              newDriverDayLock.lockedByUserCode !== userCode
            ) {
              // refresh driver day lock state
              refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
                ...newDriverDayLock,
                lockedByYou: false,
                lockedInDifferentBrowser: false,
              };
            } // else if no changes do nothing
          }
        }
      );

      // Route day locks
      Object.entries(newRouteDayLocks).forEach(
        ([routeCode, newRouteDayLock]) => {
          const routeDayLock = matrixDays[dayOfWeek].routeDayLocks[routeCode];

          // If route day lock was not present and it now is
          if (!routeDayLock) {
            hasChangedChecksum = true;
            // set route day lock as changed
            refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
              ...newRouteDayLock,
              checksum: null,
              lockedByYou: false,
              lockedInDifferentBrowser: false,
              changed: true,
            };
            // Else if current route day lock is already marked as changed, do nothing.
          } else if (routeDayLock.changed) {
            hasChangedChecksum = true;
            return;
            // Else if current route day lock checksum is not equal to new lock checksum,
          } else if (routeDayLock.checksum !== newRouteDayLock.checksum) {
            hasChangedChecksum = true;
            // set route day lock as changed
            refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
              ...newRouteDayLock,
              checksum: null,
              lockedByYou: false,
              lockedInDifferentBrowser: false,
              changed: true,
            };
            // Else if route day  was locked by you in this session
          } else if (
            routeDayLock.lockedByYou &&
            !routeDayLock.lockedInDifferentBrowser
          ) {
            // and it is no longer locked by you
            if (newRouteDayLock.lockedByUserCode !== userCode) {
              // refresh route day lock state
              refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
                ...newRouteDayLock,
                lockedByYou: false,
                lockedInDifferentBrowser: false,
              };
              // delete stored checksum
              deleteDriverManagementRouteDayChecksum({
                dayOfWeek,
                depotCode,
                routeCode,
              });
            } // else if no changes do nothing
          }
          // Else if route day was locked by someone else, or by you in other session
          else if (routeDayLock.lockedByUserCode) {
            // and it is no longer locked by the same user
            if (
              newRouteDayLock.lockedByUserCode !== routeDayLock.lockedByUserCode
            ) {
              // refresh route day lock state
              refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
                ...newRouteDayLock,
                lockedByYou: false,
                lockedInDifferentBrowser: false,
              };
            } // else if no changes do nothing
            // Else if route day was unlocked
          } else {
            // and it is now locked by you
            if (newRouteDayLock.lockedByUserCode === userCode) {
              // refresh route day lock state to indicate that it has been locked by you in other session
              refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
                ...newRouteDayLock,
                lockedByYou: true,
                lockedInDifferentBrowser: true,
              };
              // and it is now locked by someone else
            } else if (
              newRouteDayLock.lockedByUserCode &&
              newRouteDayLock.lockedByUserCode !== userCode
            ) {
              // refresh route day lock state
              refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
                ...newRouteDayLock,
                lockedByYou: false,
                lockedInDifferentBrowser: false,
              };
            } // else if no changes do nothing
          }
        }
      );
    }
  );

  return {
    refreshedDriverProfileLocks,
    refreshedMatrixDays,
    hasChangedChecksum,
  };
};

export const processDriverManagementDayLocksRefresh = ({
  userCode,
  depotCode,
  dayOfWeek,
  matrixDays,
  newDriverDayLocks,
  newRouteDayLocks,
}) => {
  const refreshedMatrixDays = {
    ...matrixDays,
    [dayOfWeek]: {
      ...matrixDays[dayOfWeek],
      driverDayLocks: { ...matrixDays[dayOfWeek].driverDayLocks },
      routeDayLocks: { ...matrixDays[dayOfWeek].routeDayLocks },
    },
  };
  let hasChangedChecksum = false;

  // Driver day locks
  Object.entries(newDriverDayLocks).forEach(
    ([driverCode, newDriverDayLock]) => {
      const driverDayLock = matrixDays[dayOfWeek].driverDayLocks[driverCode];

      // If driver day lock was not present and it now is
      if (!driverDayLock) {
        hasChangedChecksum = true;
        // set driver day lock as changed
        refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
          ...newDriverDayLock,
          checksum: null,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
          changed: true,
        };
        // Else if current driver day lock is already marked as changed, do nothing.
      } else if (driverDayLock.changed) {
        hasChangedChecksum = true;
        return;
        // Else if current driver day lock checksum is not equal to new lock checksum,
      } else if (driverDayLock.checksum !== newDriverDayLock.checksum) {
        hasChangedChecksum = true;
        // set driver day lock as changed
        refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
          ...newDriverDayLock,
          checksum: null,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
          changed: true,
        };
        // Else if driver day  was locked by you in this session
      } else if (
        driverDayLock.lockedByYou &&
        !driverDayLock.lockedInDifferentBrowser
      ) {
        // and it is no longer locked by you
        if (newDriverDayLock.lockedByUserCode !== userCode) {
          // refresh driver day lock state
          refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
            ...newDriverDayLock,
            lockedByYou: false,
            lockedInDifferentBrowser: false,
          };
          // delete stored checksum
          deleteDriverManagementDriverDayChecksum({
            dayOfWeek,
            driverCode,
          });
        } // else if no changes do nothing
      }
      // Else if driver day was locked by someone else, or by you in other session
      else if (driverDayLock.lockedByUserCode) {
        // and it is no longer locked by the same user
        if (
          newDriverDayLock.lockedByUserCode !== driverDayLock.lockedByUserCode
        ) {
          // refresh driver day lock state
          refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
            ...newDriverDayLock,
            lockedByYou: false,
            lockedInDifferentBrowser: false,
          };
        } // else if no changes do nothing
        // Else if driver day was unlocked
      } else {
        // and it is now locked by you
        if (newDriverDayLock.lockedByUserCode === userCode) {
          // refresh driver day lock state to indicate that it has been locked by you in other session
          refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
            ...newDriverDayLock,
            lockedByYou: true,
            lockedInDifferentBrowser: true,
          };
          // and it is now locked by someone else
        } else if (
          newDriverDayLock.lockedByUserCode &&
          newDriverDayLock.lockedByUserCode !== userCode
        ) {
          // refresh driver day lock state
          refreshedMatrixDays[dayOfWeek].driverDayLocks[driverCode] = {
            ...newDriverDayLock,
            lockedByYou: false,
            lockedInDifferentBrowser: false,
          };
        } // else if no changes do nothing
      }
    }
  );

  // Route day locks
  Object.entries(newRouteDayLocks).forEach(([routeCode, newRouteDayLock]) => {
    const routeDayLock = matrixDays[dayOfWeek].routeDayLocks[routeCode];
    // If route day lock was not present and it now is
    if (!routeDayLock) {
      hasChangedChecksum = true;
      // set route day lock as changed
      refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
        ...newRouteDayLock,
        checksum: null,
        lockedByYou: false,
        lockedInDifferentBrowser: false,
        changed: true,
      };
      // Else if current route day lock is already marked as changed, do nothing.
    } else if (routeDayLock.changed) {
      hasChangedChecksum = true;
      return;
      // Else if current route day lock checksum is not equal to new lock checksum,
    } else if (routeDayLock.checksum !== newRouteDayLock.checksum) {
      hasChangedChecksum = true;
      // set route day lock as changed
      refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
        ...newRouteDayLock,
        checksum: null,
        lockedByYou: false,
        lockedInDifferentBrowser: false,
        changed: true,
      };
      // Else if route day  was locked by you in this session
    } else if (
      routeDayLock.lockedByYou &&
      !routeDayLock.lockedInDifferentBrowser
    ) {
      // and it is no longer locked by you
      if (newRouteDayLock.lockedByUserCode !== userCode) {
        // refresh route day lock state
        refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
          ...newRouteDayLock,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
        };
        // delete stored checksum
        deleteDriverManagementRouteDayChecksum({
          dayOfWeek,
          depotCode,
          routeCode,
        });
      } // else if no changes do nothing
    }
    // Else if route day was locked by someone else, or by you in other session
    else if (routeDayLock.lockedByUserCode) {
      // and it is no longer locked by the same user
      if (newRouteDayLock.lockedByUserCode !== routeDayLock.lockedByUserCode) {
        // refresh route day lock state
        refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
          ...newRouteDayLock,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
        };
      } // else if no changes do nothing
      // Else if route day was unlocked
    } else {
      // and it is now locked by you
      if (newRouteDayLock.lockedByUserCode === userCode) {
        // refresh route day lock state to indicate that it has been locked by you in other session
        refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
          ...newRouteDayLock,
          lockedByYou: true,
          lockedInDifferentBrowser: true,
        };
        // and it is now locked by someone else
      } else if (
        newRouteDayLock.lockedByUserCode &&
        newRouteDayLock.lockedByUserCode !== userCode
      ) {
        // refresh route day lock state
        refreshedMatrixDays[dayOfWeek].routeDayLocks[routeCode] = {
          ...newRouteDayLock,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
        };
      } // else if no changes do nothing
    }
  });

  return {
    refreshedMatrixDays,
    hasChangedChecksum,
  };
};

export const getSavedDriverManagementDriverProfileChecksums = ({
  depotCode,
}) => {
  try {
    return (
      JSON.parse(
        localStorage.getItem(
          `DRIVER_MANAGEMENT_${depotCode}_driverProfileChecksum`
        )
      ) || {}
    );
  } catch (err) {
    return {};
  }
};

export const saveDriverManagementDriverProfileChecksums = ({
  depotCode,
  driverProfilesChecksums,
}) =>
  localStorage.setItem(
    `DRIVER_MANAGEMENT_${depotCode}_driverProfileChecksum`,
    JSON.stringify(driverProfilesChecksums)
  );

export const getSavedDriverManagementDriverDayChecksums = ({
  dayOfWeek,
  depotCode,
}) => {
  try {
    return (
      JSON.parse(
        localStorage.getItem(
          `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_driverDayChecksum`
        )
      ) || {}
    );
  } catch (err) {
    return {};
  }
};

export const saveDriverManagementDriverDayChecksums = ({
  dayOfWeek,
  depotCode,
  driverDaysChecksums,
}) =>
  localStorage.setItem(
    `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_driverDayChecksum`,
    JSON.stringify(driverDaysChecksums)
  );

export const getSavedDriverManagementRouteDayChecksums = ({
  dayOfWeek,
  depotCode,
}) => {
  try {
    return (
      JSON.parse(
        localStorage.getItem(
          `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_routeDayChecksum`
        )
      ) || {}
    );
  } catch (err) {
    return {};
  }
};

export const saveDriverManagementRouteDayChecksums = ({
  dayOfWeek,
  depotCode,
  routeDaysChecksums,
}) =>
  localStorage.setItem(
    `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_routeDayChecksum`,
    JSON.stringify(routeDaysChecksums)
  );

export const saveDriverManagementDriverProfileChecksum = ({
  driverCode,
  checksum,
}) => {
  const [depotCode] = driverCode.split("*");
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(
          `DRIVER_MANAGEMENT_${depotCode}_driverProfileChecksum`
        )
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  storedValue[driverCode] = checksum;
  localStorage.setItem(
    `DRIVER_MANAGEMENT_${depotCode}_driverProfileChecksum`,
    JSON.stringify(storedValue)
  );
};

export const deleteDriverManagementDriverProfileChecksum = ({ driverCode }) => {
  const [depotCode] = driverCode.split("*");
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(
          `DRIVER_MANAGEMENT_${depotCode}_driverProfileChecksum`
        )
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  delete storedValue[driverCode];
  localStorage.setItem(
    `DRIVER_MANAGEMENT_${depotCode}_driverProfileChecksum`,
    JSON.stringify(storedValue)
  );
};

export const deleteDriverManagementDepotDriverProfileChecksums = ({
  depotCode,
}) => {
  try {
    localStorage.removeItem(
      `DRIVER_MANAGEMENT_${depotCode}_driverProfileChecksum`
    );
  } catch {}
};

export const saveDriverManagementDriverDayChecksum = ({
  dayOfWeek,
  driverCode,
  checksum,
}) => {
  const [depotCode] = driverCode.split("*");
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(
          `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_driverDayChecksum`
        )
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  storedValue[driverCode] = checksum;
  localStorage.setItem(
    `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_driverDayChecksum`,
    JSON.stringify(storedValue)
  );
};

export const deleteDriverManagementDriverDayChecksum = ({
  dayOfWeek,
  driverCode,
}) => {
  const [depotCode] = driverCode.split("*");
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(
          `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_driverDayChecksum`
        )
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  delete storedValue[driverCode];
  localStorage.setItem(
    `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_driverDayChecksum`,
    JSON.stringify(storedValue)
  );
};

export const deleteDriverManagementDepotDriverDayChecksums = ({
  dayOfWeek,
  depotCode,
}) => {
  try {
    localStorage.removeItem(
      `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_driverDayChecksum`
    );
  } catch {}
};

export const saveDriverManagementRouteDayChecksum = ({
  dayOfWeek,
  depotCode,
  routeCode,
  checksum,
}) => {
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(
          `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_routeDayChecksum`
        )
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  storedValue[routeCode] = checksum;
  localStorage.setItem(
    `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_routeDayChecksum`,
    JSON.stringify(storedValue)
  );
};

export const deleteDriverManagementRouteDayChecksum = ({
  dayOfWeek,
  depotCode,
  routeCode,
}) => {
  let storedValue;
  try {
    storedValue =
      JSON.parse(
        localStorage.getItem(
          `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_routeDayChecksum`
        )
      ) || {};
  } catch (err) {
    storedValue = {};
  }
  delete storedValue[routeCode];
  localStorage.setItem(
    `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_routeDayChecksum`,
    JSON.stringify(storedValue)
  );
};

export const deleteDriverManagementDepotRouteDayChecksums = ({
  dayOfWeek,
  depotCode,
}) => {
  try {
    localStorage.removeItem(
      `DRIVER_MANAGEMENT_${dayOfWeek}_${depotCode}_routeDayChecksum`
    );
  } catch {}
};
